import OpenAI from 'openai';

// Initialize OpenAI client with error handling
const openai = new OpenAI({
  apiKey: import.meta.env.VITE_OPENAI_API_KEY,
  dangerouslyAllowBrowser: true
});

// Export the initialized client
export { openai };

// Export the analyze function
export const analyzeQuestion = async ({ text }) => {
  try {
    // Clean the text and extract components
    const questionText = text.replace(/###|---|\*\*/g, '').trim();
    
    // Main analysis with step-by-step reasoning
    const response = await openai.chat.completions.create({
      model: "o1-preview",
      messages: [
        {
          role: "user",
          content: "You are an expert LSAT tutor specializing in Logical Reasoning questions. Analyze the question thoroughly and provide detailed insights."
        },
        {
          role: "user",
          content: `Analyze this LSAT question in detail:\n\n${questionText}`
        }
      ],
      temperature: 0.7
    });

    const analysis = response.choices[0].message.content;
    
    // Format the analysis
    return {
      formattedAnalysis: {
        mainPoints: ["Detailed analysis of the LSAT question"],
        structure: {
          premises: [analysis]
        },
        analysis: {
          reasoning: {
            reading: analysis
          }
        }
      }
    };
  } catch (error) {
    console.error('OpenAI API Error:', error);
    throw new Error('Failed to analyze question');
  }
}; 